export default __webpack_public_path__ + "static/media/full2.12d36fca.jpg";